<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../app.logic";
  import Input from "../../components/Form/Fields/Input.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { initDetail, record, save } from "./recipe.store";
  import type { IRecipe } from "../../entities/recipe";
  import Textarea from "../../components/Form/Fields/Textarea.svelte";
  import ProductTypeDropdown from "../../components/Business/ProductTypeDropdown.svelte";
  import Tabs from "../../components/Tab/Tabs.svelte";
  import Tab from "../../components/Tab/Tab.svelte";
  import RecipeIngredientsFragment from "./RecipeIngredientsFragment.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import RecipeMaterialsFragment from "./RecipeMaterialsFragment.svelte";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit = $record != null && $record.description != "" && $record.productTypeId != null && $record.productTypeId != 0;

  enum RecipePage {
    General = 1,
    Ingredients,
    Materials,
  }

  let currentTab: RecipePage = RecipePage.General;

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<IRecipe> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/recipe/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/recipe`);
  }

  onMount(() => initDetail(oid));
</script>

<MainLayout>
  <Tabs>
    <Tab
      label="Generale"
      active={currentTab == RecipePage.General}
      on:click={(_) => {
        currentTab = RecipePage.General;
      }}
    />

    {#if !isNew}
      <Tab
        label="Ingredienti"
        active={currentTab == RecipePage.Ingredients}
        on:click={(_) => {
          currentTab = RecipePage.Ingredients;
        }}
      />

      <Tab
        label="Materiali"
        active={currentTab == RecipePage.Materials}
        on:click={(_) => {
          currentTab = RecipePage.Materials;
        }}
      />
    {/if}
  </Tabs>

  {#if $record}
    <!-- GENERAL -->
    {#if currentTab == RecipePage.General}
      <div class="columns">
        <div class="column is-12">
          <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
            <div class="columns">
              <div class="column is-6">
                <FormField>
                  <Input name="Descrizione" placeholder="" required={true} bind:value={$record.description} />
                </FormField>
              </div>
              <div class="column is-4">
                <FormField>
                  <ProductTypeDropdown name="Tipo Prodotto" phaseCode="T" required={true} bind:value={$record.productTypeId} />
                </FormField>
              </div>
              <div class="column is-2">
                <FormField>
                  <Switch name="Attiva" bind:value={$record.active} />
                </FormField>
              </div>
            </div>

            <div class="columns">
              <div class="column is-6">
                <FormField>
                  <Textarea name="Ingredienti in etichetta" placeholder="" required={false} bind:value={$record.labelIngredients} />
                </FormField>
              </div>
              <div class="column is-6">
                <FormField>
                  <Textarea name="Valori nutrizionali" placeholder="" required={false} bind:value={$record.nutritionFacts} />
                </FormField>
              </div>
            </div>
          </FormLayout>
        </div>
      </div>
    {/if}

    <!-- INGREDIENTS -->
    {#if currentTab == RecipePage.Ingredients}
      <RecipeIngredientsFragment recipeId={$record.oid} />
    {/if}
    <!-- MATERIALS -->
    {#if currentTab == RecipePage.Materials}
      <RecipeMaterialsFragment recipeId={$record.oid} />
    {/if}
  {/if}
</MainLayout>
